export const DEFAULT_ITEMS_PER_PAGE = 10;

export const prepareSearchStringForQuery = (searchString: string) => {
  if (!searchString) return "%%";

  return `%${searchString}%`;
};
